
import { useState, useEffect } from "react";
import { ConfirmaRecebimentoPecaBabita, ConsultarIPedidosEncomenda, ConsultaLojaInfo, gerarPedidoFrenteLoja  } from "../funcionalidades/bancoGet";
import GlobalVar from "./GlobalVar";
import Swal from 'sweetalert2'

function gerarPedidoFrenteLojaFunction ({item, itensNota, loja}){

    console.log(item)
    console.log(itensNota)
    return new Promise(async (resolve)=>{
        console.log("ANTES LOJA")
            const lojaInfo = await ConsultaLojaInfo({loja})
                    .then((resp)=>{
                        if(resp.Error || resp['ERROR SERVER']){
                            Swal.fire({
                                type: 'error',
                                title: 'Erro Ao Gerar Pedido',
                                text: 'Pedido Não Gerado!'
                              })
                            resolve("FIM SCRIPT")
                        }else{
                            return resp[0]
                        }
                    })
                    console.log(lojaInfo)
                    console.log("POS LOJA")
            
        const ipLoja = lojaInfo.loj_ipservidor

        await gerarPedidoFrenteLoja({item, itensNota, ipLoja})
        .then((resp)=>{
            console.log(resp)
            if(resp.Error || resp['ERROR SERVER']){
                Swal.fire({
                    type: 'error',
                    title: 'Erro Ao Gerar Pedido',
                    text: 'Pedido Não Gerado!'
                  })
                resolve("FIM SCRIPT")
            }else{
                Swal.fire({
                    type: 'success',
                    title: 'Pedido Gerado!',
                    text: 'Feche a Nota no Sistema, Documento: ' + resp.documento,
                    showConfirmButton: true
                  })
                  resolve("SUCCESS")
            }
        })
        
        //  await NotaFrente_atualizarParametros({ipLoja})
        //  NotaFrente_dadosClientes({ipLoja, cpfcnpj})
        //  NotaFrente_pedidos({ipLoja, documento, dadosCpfCnpj, dadosNome})
        //  NotaFrente_buscarProdutos({ipLoja, codigofabSan, codigoproSan, dadosCpfCnpj})
        //  NotaFrente_ipedidos({ipLoja, documento, codigofab, codigopro, codigobas, preco, cpfcnpj})
    })

}

const ComponenteNotaExpedicao = ({item, ativaResp, setShowAlert, usuarioTipo, atualizaConsulta,
    setatualizaConsulta, usuario})=>{

    const [showItens, setShowItens] = useState(false)
    const [itensNota, setItensNota] = useState('Carregando ...')
    const [ipedidos, setIpedidos] = useState('Carregando ...')

    let data = GlobalVar.formatarData(new Date((item.data)))
    let dataCab = `${data[0]}/${data[1]}/${data[2]}`
    let dataItem = `${data[2]}-${data[1]}-${data[0]}`
    // const item = {...JSON.parse(JSON.stringify(item)), tipo: item.tipo
    //     destino}


    useEffect(()=>{
        if(showItens){
                ConsultarIPedidosEncomenda({documento: item.documento})
                    .then((resp)=>{
                        if(resp.Error){
                            setShowAlert(resp.Error);
                        }else{
                            const respostaTratada = resp.reduce((acc, curr) => {
                                if(!acc[curr.rev_nom]) {
                                    acc[curr.rev_nom] = [];
                                }
                                acc[curr.rev_nom].push(curr);
                                return acc;
                            }, {});
                            setItensNota(respostaTratada)
                            setIpedidos(resp)
                        }
                        
                    })
        }
    },[showItens])


    const confirmarRecebimento = async (documento)=>{
        await ConfirmaRecebimentoPecaBabita({DOCUMENTO: documento})
        .then((resp)=>{
            if(resp.Error){
                
            }else{
                setatualizaConsulta(!atualizaConsulta)
            }
            
        })
    }
    

    return <div className="itemNota expedicao">
       <div className={`cabecalhoNota expedicao`} onClick={()=>setShowItens(!showItens)}>
  
  <div className="linha linha1">
      
    <div className="documento">{ativaResp ? 'Doc.: ': ''}{item.documento}</div>
    <div className="doctoclie">{item.doctoclie}</div>
    <div className="nomeclie">{item.nomeclie}</div>
    <div className="vendedora">Vend.: {item.vendedora}</div>
    <div className="dtPedido">{dataCab}</div>
  </div>

  <div className="linha linha2">
    <div className="qtdeTotal">Qtde Total.: {item.totalitens} UNI</div>
    <div className="valorTotal">Valor Total: {GlobalVar.converteReais(item.totalgeral)}</div>
  </div>

</div>

 

        {showItens ?<div className="itensNota">
             <div className='lineBar'></div>

             {item.status !== 'RECEBIDO PELA BABITA' && item.status !== 'PEDIDO ENTREGUE PELA BABITA' ? <div className="buttonEntregaPedidoFornecedor" onClick={async ()=> {
                     await confirmarRecebimento(item.documento)
             }}>Confirmar Recebimento</div> : item.documento_frenteloja ? <div className="buttonEntregaPedidoFornecedor" style={{cursor: 'none'}}>Nota Tirada. Doc.: {item.documento_frenteloja}</div>
                 : itensNota !== 'Carregando ...' ? <div
                   className="buttonEntregaPedidoFornecedor"
                   onClick={async () => {
                     const result = await Swal.fire({
                       title: 'Confirmar ação?',
                       text: 'Deseja realmente tirar a nota?',
                       icon: 'warning',
                       showCancelButton: true,
                       confirmButtonText: 'Sim, continuar',
                       cancelButtonText: 'Cancelar'
                     });
                 
                     if (result.isConfirmed) {
                       await gerarPedidoFrenteLojaFunction({
                         item,
                         itensNota: ipedidos,
                         loja: usuario.usu_loja
                       });
                 
                       setatualizaConsulta(!atualizaConsulta);
                 
                     }
                   }}
                 >
                   Tirar Nota
                 </div> : <></>}

            {itensNota !== 'Carregando ...' ? Object.keys(itensNota).map((revistaColecaoItens,i)=>{
                    const itensArr = itensNota[revistaColecaoItens]
                    
                    return  <>
                    

                    <div className="titleRevMov" key={`title${item.documento}`}>{revistaColecaoItens}</div>

                        <div className="itemsMov" key={`itens${item.documento}`}>

                            {itensArr.map((subItem,i)=>{
                               return <>
                                <div className="subItemMov" key={`subItens${item.documento}`}>
                                    <div>{subItem.fabricante.substr(0,24)}</div>
                                    <div>{subItem.item.substr(0,24)}</div>
                                    <div>COR: {subItem.procor_descricao_cor.substr(0,12)}</div>
                                    {ativaResp ? <div className="flexTam">
                                        <div>TAM.: {subItem.tam_nom}</div>
                                        <div className='qtde'>{`${subItem.qtde}`} UN</div>
                                    </div> : <>
                                    <div>TAM.: {subItem.tam_nom}</div>
                                        <div className='qtde'>{`${subItem.qtde}`} UN</div>
                                    </>}
                                        
                                </div>
                                <div className='lineBar'></div>
                            </>
                            })}
                            <div className="totalItemMov">
                                <div>Items: {`${itensArr.reduce((acc, curr) => {
                                            return acc + parseInt(curr.qtde);
                                        }, 0)}`}</div>
                                <div>Total: R$ {`${itensArr.reduce((acc, curr) => {
                                            return acc + parseFloat(curr.prcvenda)*parseInt(curr.qtde);
                                        }, 0).toFixed(2)}`.replaceAll(".",",")}</div>
                            </div>
                            
                        </div>
                        </> 
                    }) : 'Carregando ...'}  
        </div> : <></>}
    </div>
}

export default ComponenteNotaExpedicao;